module.exports = __webpack_public_path__ + "img/loader.0e970009.gif";